/**
 * Shared collapsible-section shell used by every filter group in the
 * sidebar / mobile sheet.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1253–1285.
 */

"use client";

import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

interface FilterSectionProps {
  title: string;
  children: ReactNode;
  count?: number;
  isOpen: boolean;
  onToggle: (title: string) => void;
}

export function FilterSection({
  title,
  children,
  count,
  isOpen,
  onToggle,
}: FilterSectionProps) {
  return (
    <div className="border-b border-border last:border-0">
      <button
        type="button"
        onClick={() => onToggle(title)}
        aria-expanded={isOpen}
        className="flex w-full items-center justify-between py-3.5 text-left text-sm font-semibold text-foreground transition-colors hover:text-primary"
      >
        <span className="flex items-center gap-2">
          {title}
          {count !== undefined && count > 0 && (
            <span className="flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-medium text-primary-foreground">
              {count}
            </span>
          )}
        </span>
        <ChevronDown
          className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>
      {isOpen && <div className="pb-4">{children}</div>}
    </div>
  );
}
